module.exports = __webpack_public_path__ + "media/dashboard/assets/images/commslayer_logo-4d544d98a3088808e2deed5edbac139c.svg";